export const English = {
    MODULE: { LABEL: 'Access' },
    LOGIN: {
        SEO_TITLE: 'Manage portfolio',
        SEO_DESCRIPTION: 'Private access to the portfolio administration panel.',
        STATUS: '',
        EYEBROW: '',
        TITLE: '',
        TITLE_ACCENT: '',
        DESCRIPTION: '',
        CARD_EYEBROW: '',
        CARD_TITLE: 'Authorized access',
        CARD_SUBTITLE: '',
        SUBMIT: 'Sign in',
        SUBMIT_LOADING: 'Checking access',
    },
    FIELDS: {
        EMAIL_LABEL: 'Email',
        EMAIL_PLACEHOLDER: 'Email',
        PASSWORD_LABEL: 'Password',
        PASSWORD_PLACEHOLDER: 'Password',
        REMEMBER_ME: 'Remember me',
    },
};
